var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"configs main-section"},[_c('div',{staticClass:"section-body scroll-bar dashboard-finance-body"},[_c('TabFinance',{attrs:{"liste_personnel_roles":_vm.liste_personnel_roles}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }